// extracted by mini-css-extract-plugin
export default {"uploadTasksContainer":"styles_uploadTasksContainer__YqG9P","actionBtn":"styles_actionBtn__aIPnK","uploadIcon":"styles_uploadIcon__DHm+2"};